import { Base } from './Base'

export class NumberInput extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element)
    this.init()
  }

  init() {
    this.bindFunctions()
    this.setEventListeners()
  }

  setEventListeners() {
    const { increment, decrement } = this.refs

    increment.addEventListener('click', this.more)
    decrement.addEventListener('click', this.less)
  }

  bindFunctions() {
    this.more = this.more.bind(this)
    this.less = this.less.bind(this)
  }

  more() {
    this.update(1)
  }

  less() {
    this.update(-1)
  }

  update(by) {
    const { input, output } = this.refs

    input.value = parseInt(input.value) + by
    output.textContent = input.value
  }

  cleanup() {}
}
